import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import BigCalendar from 'react-big-calendar';
import moment from 'moment';
import { translate, Trans } from 'react-i18next'

import {
  setSelectedDate,
  toggleCalendar
} from '../../actions/dateSelector';

import './dateselect.scss';

import { Icon } from '../icons';
import Button from './Button';

BigCalendar.setLocalizer(
  BigCalendar.momentLocalizer(moment)
);

// TODO: convert date to moment just once
const DateSelect = ({ t, date, onDateChange, onDateClick, calendarOpen, events, todaysEvents }) => {
  const momentDate = moment(new Date(date));

  return (
    <div className="date-select-container">
      <div className="date-select">
        <a href="#" onClick={() => onDateChange(momentDate.subtract(1, calendarOpen ? 'month' : 'day'))} className={"date-select-nav date-prev " + (momentDate > moment() ? 'active' : 'inactive')}>
          <Icon className="date-arrow" type="arrow-left" />
        </a>
        <a href="#" onClick={onDateClick} className="date">
          <Icon className="date-calendar" type="calendar" />
          <div className="date-day">{ momentDate.format('DD') }</div>
          <div className="date-month">{ t(momentDate.format('MMMM')) }</div>
          <div className="date-year">{ momentDate.format('YYYY') }</div>
        </a>
        <a href="#" onClick={() => onDateChange(momentDate.add(1, calendarOpen ? 'month' : 'day'))} className="date-select-nav date-next active">
          <Icon className="date-arrow" type="arrow-right" />
        </a>
        <div className="event-small-calendar">
          {calendarOpen && <BigCalendar
            titleAccessor="name"
            events={events}
            views={['month']}
            date={momentDate.toDate()}
            onNavigate={e => { onDateChange(moment(e)); onDateClick() }}
            toolbar={false}
            selectable={true} />
          }
        </div>
      </div>
      <ul className="todays-event-list">
        {todaysEvents.map(event =>
          <li key={event.id}>
            <Link to={`/organisations/${event.organisation_id}/events/${event.id}/schedules`}>
              <Icon className="event-icon" type="info" />
              <span className="event-text">{event.description}</span>
            </Link>
          </li>
        )}
      </ul>
    </div>
  )
}

export default translate('events')(connect(
  ({ ui, events }) => ({
    date: ui.dateSelector.date,
    calendarOpen: ui.dateSelector.calendarOpen,
    events: events.data,
    todaysEvents: events.data.filter(e => moment(e.event_date).isSame(new Date(ui.dateSelector.date), 'day'))
  }),
  dispatch => ({
    onDateChange: (date) => dispatch(setSelectedDate(date)),
    onDateClick: () => dispatch(toggleCalendar())
  })
)(DateSelect));



// WEBPACK FOOTER //
// ./src/components/layout/DateSelect.js